import React, { Component, useState, useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, Cell, DialogContainer, Grid, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
// import TableRow from '../component/TableRow';
import instructorStyles from '../css/instructorStyles.css.js';
import styles from '../css/styles.css.js';
import SFCustomTable from '../component/custom/SFCustomTable.js';
import moment from 'moment';
import { MdEdit } from "react-icons/md";
import { FiTrash2 } from "react-icons/fi";
import { AppProperties } from '../common/function.js';
import HelpText from '../lib/help-text.js';

import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Button as MButton, Typography, TextField as MTextField, CircularProgress } from '@mui/material';
import Toggle from 'react-toggle';
import { removeQueryParams } from '../common/function.js';
import { FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import SFUserName from './AssignmentMatrix/components/SFUserName.jsx';
import SFSegmentedTabs from './AssignmentMatrix/components/SFSegmentedTabs.jsx';
import SFUserDetailModal from './AssignmentMatrix/components/SFUserDetailModal.jsx';


let instructor = {
    instructor_name: '',
    instructor_id: '',
    instructor_first_name: '',
    instructor_last_name: ''
}

const Approval = {
    REJECT: -1,
    PENDING: 0,
    APPROVED: 1,
}

export default class Instructors extends Component {

    appProperties = AppProperties();

    helpTextModel = new HelpText()

    constructor(props) {
        super(props);
        this.state = {
            instructors: [],
            temp_instructor: instructor,
            temp_id: '',
            visible: false,
            addMode: true,
            temp_new_instructor: instructor,
            newVisible: false,
            loading: false,
            showActionRequired: false,
            selectedUserName: null,
            showRejectUser: false,
            hideRejectBtn: false,
            columns: [
                {
                    name: <div className='sf-data-table-header'>SF ID</div>,
                    selector: row => row.instructor_id,
                    sortable: true,
                    width: '100px',
                },
                {
                    name: <div className='sf-data-table-header'>User ID</div>,
                    selector: row => <SFUserName userName={row.instructor_name} />,
                    sortable: true,
                    // width:'150px',
                },
                {
                    name: <div className='sf-data-table-header'>First Name</div>,
                    selector: row => row.instructor_first_name,
                    sortable: true,
                    // width:'150px',
                },
                {
                    name: <div className='sf-data-table-header'>Last Name</div>,
                    selector: row => row.instructor_last_name,
                    sortable: true,
                    // width:'150px',
                },
                {
                    name: <div className='sf-data-table-header'>Institution</div>,
                    selector: row => row.organization,
                    sortable: true,
                },
                {
                    name: <div className='sf-data-table-header'>Created At</div>,
                    selector: row => moment(row.created_at).format("MM/DD/YYYY hh:mm:ss a"),
                    sortable: true,
                },
                {
                    name: <div className='sf-data-table-header'>Active</div>,
                    selector: row => row.active,
                    width: '100px',
                    cell: (row, rowIndex) => {
                        console.debug("row>>??", row)
                        return (
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <Toggle
                                    onClick={() => this.activateUser(rowIndex)}
                                    icons={false}
                                    className='custom-react-toggle'
                                    checked={row.active === 1}
                                />
                            </div>
                        )
                    },
                    sortable: false,
                },
                {
                    name: <div className='sf-data-table-header' style={{ textAlign: 'center' }}>Course Creation<br />Access</div>,
                    width: '200px',
                    selector: row => row.active,
                    cell: (row, rowIndex) => {
                        console.debug("row>>??", row)
                        return (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: 'center', width: '100%' }}>
                                <Toggle
                                    onClick={() => {
                                        let instructor = this.state.instructors[rowIndex];
                                        let accessValue = instructor.instructor_course_creation_access === 0 ? 1 : 0;
                                        const payload = {
                                            instructor_name: instructor.instructor_name,
                                            instructor_course_creation_access: accessValue,

                                            rowIndex,
                                        }
                                        this.updateCourseCreationAccess(payload);
                                    }}
                                    icons={false}
                                    className='custom-react-toggle'
                                    checked={row.instructor_course_creation_access === 1}
                                />
                            </div>
                        )
                    },
                    sortable: false,
                },
                {
                    name: <div className='sf-data-table-header'>Actions</div>,
                    sortable: false,
                    cell: (_, rowIndex) => {
                        return (
                            <div>
                                <IconButton>
                                    <MdEdit color='#3d5e9c' onClick={() => this.editInstructor(rowIndex)} />
                                </IconButton>
                                <IconButton>
                                    <FiTrash2 color='#bb0000' onClick={() => this.delete(rowIndex)} />
                                </IconButton>
                            </div>
                        )
                    },
                    sortable: false,
                },
            ],
            instructorTabValue: 'approved_instructors',
            pendingInstructors: [],
            pendingInstructorColumns: [
                {
                    name: <div className='sf-data-table-header'>SF ID</div>,
                    selector: row => row.instructor_id,
                    sortable: true,
                },
                {
                    name: <div className='sf-data-table-header'>Username</div>,
                    selector: row => <SFUserName userName={row.instructor_name} />,
                    sortable: true,
                },
                {
                    name: <div className='sf-data-table-header'>Full Name</div>,
                    selector: row => `${row.instructor_first_name} ${row.instructor_last_name}`,
                    sortable: true,
                },
                {
                    name: <div className='sf-data-table-header'>Email</div>,
                    selector: row => row.email,
                    sortable: true,
                },
                {
                    name: <div className='sf-data-table-header'>Institution</div>,
                    selector: row => row.organization,
                    sortable: true,
                },
                {
                    name: <div className='sf-data-table-header'>Actions</div>,
                    sortable: false,
                    width: '300px',
                    cell: (row, rowIndex) => {
                        return (
                            <div style={{ display: 'flex', gap: "6px" }}>
                                <MButton variant='contained' color='primary' onClick={() => {
                                    this.setState({
                                        showActionRequired: true,
                                        selectedUserName: row.instructor_name,
                                        hideRejectBtn: false,
                                    })
                                }}>
                                    Action Required
                                </MButton>
                                {/* <MButton variant='contained' color='success'  startIcon={<FaCheck />}
                            onClick={() => {
                                this.handleApproval(row.instructor_name, Approval.APPROVED)
                            }}
                           >
                                Approve
                           </MButton>
                           <MButton variant='contained' color='error'  startIcon={<IoClose />}
                            onClick={() => {
                                this.handleApproval(row.instructor_name, Approval.REJECT)
                            }}
                           >
                                Reject
                           </MButton> */}
                            </div>
                        )
                    },
                },
            ],
            rejectedInstructors: [],
            rejectedInstructorColumns: [
                {
                    name: <div className='sf-data-table-header'>SF ID</div>,
                    selector: row => row.instructor_id,
                    sortable: true,
                    width:'100px',
                },
                {
                    name: <div className='sf-data-table-header'>Username</div>,
                    selector: row => <SFUserName userName={row.instructor_name} />,
                    sortable: true,
                },
                {
                    name: <div className='sf-data-table-header'>Full Name</div>,
                    selector: row => `${row.instructor_first_name} ${row.instructor_last_name}`,
                    sortable: true,
                },
                {
                    name: <div className='sf-data-table-header'>Email</div>,
                    selector: row => row.email,
                    sortable: true,
                },
                {
                    name: <div className='sf-data-table-header'>Institution</div>,
                    selector: row => row.organization,
                    sortable: true,
                },
                {
                    name: <div className='sf-data-table-header'>Rejection Reason</div>,
                    selector: row => row.rejection_reason,
                    sortable: true,
                    width: "300px",
                },
                {
                    name: <div className='sf-data-table-header'>Actions</div>,
                    sortable: false,
                    width: '300px',
                    cell: (row, rowIndex) => {
                        return (
                            <div style={{ display: 'flex', gap: "6px" }}>
                                <MButton variant='contained' color='primary'
                                    onClick={() => {
                                        // this.handleApproval(row.instructor_name, Approval.APPROVED)
                                        this.setState({
                                            showActionRequired: true,
                                            selectedUserName: row.instructor_name,
                                            hideRejectBtn: true
                                        })
                                    }}
                                >
                                    Action Required
                                </MButton>
                                {/* <MButton variant='contained' color='success' startIcon={<FaCheck />}
                                    onClick={() => {
                                        this.handleApproval(row.instructor_name, Approval.APPROVED)
                                    }}
                                >
                                    Approve
                                </MButton> */}
                            </div>
                        )
                    },
                },
            ],
            rejectionLoading: false,
        };


        this.deleteInstructor = this.deleteInstructor.bind(this);
        this.addInstructor = this.addInstructor.bind(this);
        this.changeInstructorName = this.changeInstructorName.bind(this);
        this.updateInstructor = this.updateInstructor.bind(this);
        this.changeInstructorFirstName = this.changeInstructorFirstName.bind(this);
        this.changeInstructorLastName = this.changeInstructorLastName.bind(this);
        this.changeNewInstructorName = this.changeNewInstructorName.bind(this);

    }

    componentWillUpdate() {
        console.log("componentWillUpdate");
        this.addBreadCrumbs();
    }

    activateUser = (rowIndex) => {
        let instructor = this.state.instructors[rowIndex];
        let activeValue = instructor.active === 0 ? 1 : 0;
        ApiRequestService({
            method: 'post',
            url: '/activateUser',
            data: {
                instructor_name: instructor.instructor_name,
                active: activeValue
            }
        })
            .then(res => {
                if (res && res.data && res.data.status === 0) {
                    let tempInstructors = [...this.state.instructors];
                    tempInstructors[rowIndex].active = activeValue;
                    this.setState({
                        instructors: tempInstructors
                    })

                    const msg = activeValue === 1 ? "User activated successfully" : "User deactivated successfully";

                    NotificationManager.success(msg, "", 3000)
                } else {
                    NotificationManager.error(res?.data?.message, "Error", 3000)
                }
            })
    }

    updateCourseCreationAccess = (payload) => {
        ApiRequestService({
            method: 'post',
            url: '/updateCourseCreationAccess',
            data: payload
        })
            .then(res => {
                if (res && res.data && res.data.status === 0) {
                    let tempInstructors = [...this.state.instructors];
                    tempInstructors[payload.rowIndex].instructor_course_creation_access = payload.instructor_course_creation_access;
                    this.setState({
                        instructors: tempInstructors
                    })

                    const msg = payload.instructor_course_creation_access === 1 ? "Course creation access granted successfully" : "Course creation access revoked successfully";

                    NotificationManager.success(msg, "", 3000)
                } else {
                    NotificationManager.error(res?.data?.message, "Error", 3000)
                }
            })
    }

    addBreadCrumbs = () => {
        console.log("Sections AddBreadCrumbs");
        this.props.replaceBreadCrumb([
            {
                "name": "Settings",
                "type": "",
                "onclickPath": "SettingsPage"
            },
            {
                "name": "All Instructors",
                "type": "",
                "onclickPath": "instructors"
            }
        ]);
    }

    componentWillMount() {
        this.getApprovedInstructors();
        this.getPendingInstructors();
        this.getRejectedInstructors();
    }

    getApprovedInstructors = () => {
        this.setState({
            loading: true
        });
        ApiRequestService({
            method: 'post',
            url: '/getAllInstructors'

        })
            .then(res => {
                let data = [];
                if (res && res.data && res.data.data) {
                    data = res.data.data.instructor_names;
                }

                this.setState({
                    instructors: data,
                });
            }).finally(() => {
                this.setState({
                    loading: false
                });
            })
    }

    getPendingInstructors = () => {
        this.setState({
            loading: true
        });
        ApiRequestService({
            method: 'GET',
            url: '/getPendingInstructors'
        })
            .then(res => {
                let data = [];
                if (res && res.data && res.data.data) {
                    data = res.data.data;
                }
                this.setState({
                    pendingInstructors: data,
                });
            }).finally(() => {
                this.setState({
                    loading: false
                });
            })
    }

    getRejectedInstructors = () => {
        this.setState({
            loading: true
        });
        ApiRequestService({
            method: 'GET',
            url: '/getRejectedInstructors'
        })
            .then(res => {
                let arr = [];
                if (res && res.data && res.data.data) {
                    arr = res.data.data;
                }
                this.setState({
                    rejectedInstructors: arr
                });
            }).finally(() => {
                this.setState({
                    loading: false
                });
            })
    }

    componentDidMount() {
        // If query params has approval
        if (this.props.location && this.props.location.query && this.props.location.query.approval) {
            let approval = this.props.location.query.approval;
            let username = this.props.location.query.username;
            if (approval === "pending" && username) {
                this.getPendingInstructors();
                this.setState({
                    instructorTabValue: "pending_approvals",
                    showActionRequired: true,
                    selectedUserName: username
                });
            }
        }
    }


    addInstructor(payload) {
        this.setState({
            loading: true
        });
        ApiRequestService({
            method: 'post',
            url: '/addInstructor',
            data: payload
        })
            .then(res => {
                console.log("Add Instructor response : ", res);
                let newInstructors = [];
                if (this.state.instructors) {
                    newInstructors = [...this.state.instructors];
                }
                if (res.data.status === 1) {
                    NotificationManager.error(res.data.message, 'Error - User Not Found', 10000);
                    this.newHide()
                    return
                }
                else if (res.data.data !== undefined && res.data.data !== null) {
                    newInstructors.push({
                        instructor_name: res.data.data.instructor_name,
                        instructor_id: res.data.data.instructor_id,
                        instructor_first_name: res.data.data.instructor_first_name,
                        instructor_last_name: res.data.data.instructor_last_name,
                        instructor_course_creation_access: res.data.data.instructor_course_creation_access
                    });
                }
                console.debug("newInstructors??", newInstructors)
                this.setState({
                    instructors: newInstructors
                })
                this.newHide()
                removeQueryParams();
                NotificationManager.success("User has been successfully added as an instructor.", "", 3000);
            }).finally(() => {
                this.setState({
                    loading: false
                });
            })
    }

    editInstructor(id) {


        this.setState({
            temp_instructor: this.state.instructors[id],
            temp_id: id,
            addMode: false
        })
        this.show()
    }

    updateInstructor() {
        console.log("Editing subject :" + this.state.temp_instructor.instructor_id);

        const payload = this.state.temp_instructor

        ApiRequestService({
            method: 'post',
            url: '/updateInstructor',
            data: payload

        })

            .then(res => {
                console.log(res);
                console.log("UpdateInstructor State: ", this.state.instructors);
                this.setState({
                    instructors: this.state.instructors,
                    temp_instructor: instructor
                })
                this.hide()
            })


    }
    deleteInstructor(id) {
        this.setState({ loading: true });
        const payload = {
            instructor_id: this.state.instructors[id].instructor_id,
            instructor_name: this.state.instructors[id].instructor_name
        }
        ApiRequestService({
            method: 'post',
            url: '/deleteInstructor',
            data: payload

        })

            .then(res => {
                if (res && res.data && res.data.status === 0) {
                    let tempInstructors = [...this.state.instructors];
                    tempInstructors.splice(id, 1)
                    this.setState({
                        instructors: tempInstructors,
                    })
                } else {
                    NotificationManager.error(res?.data?.error, "Error", 3000);
                }
            }).finally(() => {
                this.setState({ loading: false });
            })


    }
    changeNewInstructorName(user, value) {
        let temp_instructor_local = this.state.temp_new_instructor;
        temp_instructor_local.instructor_name = value
        this.setState({
            temp_new_instructor: temp_instructor_local
        });
    }

    changeInstructorName(userId) {
        let temp_instructor_local = this.state.temp_instructor;
        temp_instructor_local.instructor_name = userId
        this.setState({
            temp_instructor: temp_instructor_local
        });
    }

    changeInstructorFirstName(firstName) {
        let temp_instructor_local = this.state.temp_instructor;
        temp_instructor_local.instructor_first_name = firstName
        this.setState({
            temp_instructor: temp_instructor_local
        });
    }

    changeInstructorLastName(lastName) {
        let temp_instructor_local = this.state.temp_instructor;
        temp_instructor_local.instructor_last_name = lastName
        this.setState({
            temp_instructor: temp_instructor_local
        });
    }


    newShow = (username) => {
        let tempInst = {
            ...instructor,
            instructor_name: username ? username : "",
        }
        this.setState({ temp_new_instructor: tempInst, newVisible: true });
    };

    newHide = () => {
        this.setState({ newVisible: false, visible: false });
    };

    show = () => {
        this.setState({ visible: true });
    };

    hide = () => {
        this.setState({
            newVisible: false, visible: false,
            addMode: true
        });
    };
    instPage() {
        browserHistory.push('/instructors')
    }
    delete(id) {
        confirmAlert({
            title: 'Are you sure want to delete this instructor?',
            message: 'Press Confirm to submit',

            cancelLabel: 'Confirm',
            confirmLabel: 'Cancel',
            onCancel: () => this.deleteInstructor(id)
        })
    };


    tabOnChange = (val) => {
        if (val === "approved_instructors") {
            this.getApprovedInstructors();
        } else if (val === "pending_approvals") {
            this.getPendingInstructors();
        } else {
            this.getRejectedInstructors();
        }
        this.setState({
            instructorTabValue: val,
        })
    }

    handleApproval = (name, approval, reason) => {
        const payload = {
            instructor_name: name,
            approval,
            rejection_reason: reason,
        }
        console.debug("payload", payload);
        this.setState({rejectionLoading: true});
        ApiRequestService({
            method: 'POST',
            url: '/updateUserApproval',
            data: payload,
        })
            .then(res => {
                if (res && res.data && res.data.message) {
                    NotificationManager.error(res.data.message, "ERROR", 4000);
                } else {
                    if (this.state.instructorTabValue === "pending_approvals") {
                        let tempPendingInstructors = [...this.state.pendingInstructors];
                        let index = tempPendingInstructors.findIndex(inst => inst.instructor_name === payload.instructor_name);
                        if (index > -1) {
                            tempPendingInstructors.splice(index, 1)
                            this.setState({
                                pendingInstructors: tempPendingInstructors,
                            })
                            if (payload.approval === 1) {
                                NotificationManager.success("Successfully approved the user", "", 4000);
                                this.getApprovedInstructors();
                            } else {
                                NotificationManager.success("Successfully rejected the user", "", 4000);
                                this.getRejectedInstructors();
                            }
                        }
                    } else {
                        if (this.state.instructorTabValue === "rejected_approvals") {
                            NotificationManager.success("Successfully approved the user", "", 4000);
                            this.getRejectedInstructors();
                        }
                    }
                }
            }).finally(() => {
                this.setState({ showRejectUser: false, selectedUserName: null, showActionRequired: false, rejectionLoading: false });
            })
    }

    render() {

        let button = null;
        if (this.state.addMode) {
            button = <Button raised primary onClick={() => {
                const payload = {
                    instructor_name: this.state.temp_new_instructor.instructor_name
                }
                this.addInstructor(payload);
            }}>Add Instructor</Button>
        }
        else {
            button = <Button raised primary onClick={this.updateInstructor}>Update Instructor</Button>
        }
        var cancelButton = <Button float primary  onClick={this.hide}>Cancel</Button>

        const actions = [];
        actions.push(cancelButton);
        actions.push(button);



        return (
            <React.Fragment>
                <Grid gutter={0} key="InstructorTableGrid">
                    <Cell size={12} style={instructorStyles.instructorTitle}>
                        Instructors
                        <Button className="archive-button" primary raised
                            style={{ float: "right" }}
                            disabled={this.state.loading}
                            onClick={() => this.newShow()}>
                            Add a New Instructor
                        </Button>
                    </Cell>
                    <Cell size={6} style={{ marginTop: '0', marginBottom: '0', marginLeft: '2.8rem' }}>
                        <SFSegmentedTabs
                            id="approval_instructors"
                            tabs={[
                                { label: `Approved Instructors (${this.state.instructors?.length})`, value: 'approved_instructors' },
                                { label: `Pending Approvals (${this.state.pendingInstructors?.length})`, value: 'pending_approvals' },
                                { label: `Rejected Approvals (${this.state.rejectedInstructors?.length})`, value: 'rejected_approvals' },
                            ]}
                            value={this.state.instructorTabValue}
                            handleChange={(newValue) => {
                                this.tabOnChange(newValue);
                            }}
                        />
                        {/* <SegmentedControl 
                        name="approval_instructors"
                        style={{color: '#bb0000'}}
                        value={this.state.instructorTabValue}
                        options ={[
                            { label: `Approved Instructors (${this.state.instructors?.length})`, value:'approved_instructors', default: true },
                            { label: `Pending Approvals (${this.state.pendingInstructors?.length})`, value:'pending_approvals' },
                            { label: `Rejected Approvals (${this.state.rejectedInstructors?.length})`, value:'rejected_approvals' },
                        ]}
                        setValue={value => this.tabOnChange(value)}
                    /> */}
                    </Cell>
                    <Cell size={12}>

                        {this.state.instructorTabValue === "approved_instructors" ?
                            <SFCustomTable
                                loading={this.state.loading}
                                columns={this.state.columns}
                                selectableRows={false}
                                data={this.state.instructors}
                                topPagination={false}
                                handleRowClick={(instructor) => {
                                    let url = 'ICSMappings?instructor_id=' + instructor.instructor_id + '&instructor_name=' +
                                        instructor.instructor_name + '&instructor_first_name=' + instructor.instructor_first_name + '&instructor_last_name=' + instructor.instructor_last_name
                                    browserHistory.push(this.appProperties.baseFolder + url);
                                }}
                                bottomPagination={true}
                                defaultRowsPerPage={20}
                                showSearch={true}
                                searchPlaceholder={"Search by any coulmns"}
                                searchByFields={["instructor_first_name", "instructor_last_name", "instructor_name", "instructor_id"]}
                            // onPagination={this.handlePagination}
                            />
                            :
                            (this.state.instructorTabValue === "pending_approvals" ?
                                <SFCustomTable
                                    loading={this.state.loading}
                                    columns={this.state.pendingInstructorColumns}
                                    selectableRows={false}
                                    data={this.state.pendingInstructors}
                                    topPagination={false}
                                    handleRowClick={() => { }}
                                    bottomPagination={true}
                                    defaultRowsPerPage={20}
                                    showSearch={true}
                                    searchPlaceholder={"Search by any coulmns"}
                                    searchByFields={["instructor_name", "email", "instructor_id"]}
                                />
                                :
                                <SFCustomTable
                                    loading={this.state.loading}
                                    columns={this.state.rejectedInstructorColumns}
                                    selectableRows={false}
                                    data={this.state.rejectedInstructors}
                                    topPagination={false}
                                    handleRowClick={() => { }}
                                    bottomPagination={true}
                                    defaultRowsPerPage={20}
                                    showSearch={true}
                                    searchPlaceholder={"Search by any coulmns"}
                                    searchByFields={["instructor_name", "email", "instructor_id"]}
                                />
                            )
                        }

                        {/* <table style={instructorStyles.instructorTable}>
                        <thead style={instructorStyles.thead} >
                            <tr>
                            <th>ID</th>
                            <th>USER ID</th>
                            <th>First NAME</th>
                            <th>LAST NAME</th>
                            <th>Actions</th>
                            </tr>

                        </thead>

                        <tbody>

                            {this.state.instructors?this.state.instructors.map((instructor, i) => <TableRow key = {instructor.instructor_id}
                            data = {instructor}
                            id = {instructor.instructor_id}
                            name = {instructor.instructor_name}
                            title = {"Instructors"}
                            type = {"instructorsList"}
                            url = {'ICSMappings?instructor_id=' + instructor.instructor_id  +'&instructor_name=' +
                             instructor.instructor_name+ '&instructor_first_name=' + instructor.instructor_first_name + '&instructor_last_name=' + instructor.instructor_last_name}
                            onEditClick = {() =>this.editInstructor(i)}
                            pushId ={"instructor"}
                            onDeleteClick = {() =>this.delete(i)} />):null}
                        </tbody>
                    </table> */}
                    </Cell>
                </Grid>

                {/* Add instructor dialog */}
                <Dialog open={this.state.newVisible} onClose={() => {
                    this.newHide();
                }} maxWidth="sm" fullWidth>
                    <DialogTitle>
                        New Instructor
                    </DialogTitle>
                    <DialogContent>
                            <TextField
                                onChange={value => this.changeNewInstructorName('userId', value)}
                                defaultValue={this.state.temp_new_instructor.instructor_name}
                                id="instrId" name="instructor_name"
                                placeholder="Enter the name"
                                className="md-cell md-cell--12"
                                required
                            />
                    </DialogContent>
                    <DialogActions>
                        <Button flat primary  onClick={this.hide}>Cancel</Button>

                        {this.state.addMode ?
                            (
                                <Button raised primary 
                                disabled={!this.state.temp_new_instructor.instructor_name}
                                onClick={() => {
                                    const payload = {
                                        instructor_name: this.state.temp_new_instructor.instructor_name
                                    }
                                    this.addInstructor(payload);
                                }}>Add Instructor</Button>
                            )
                        : 
                            (
                                <Button raised primary onClick={this.updateInstructor}>Update Instructor</Button>
                            )
                        }
                    </DialogActions>
                </Dialog>

                {/* <DialogContainer
                    modal
                    id="simple-action-dialog"
                    visible={this.state.newVisible}
                    onHide={this.newHide}
                    actions={actions}
                    //title="New Instructor"
                    width="500px"
                    key="AddInstructorDialog"
                >
                    <h2><label for="instrId">New Instructor</label></h2>
                    <TextField
                        onChange={value => this.changeNewInstructorName('userId', value)}
                        defaultValue={this.state.temp_new_instructor.instructor_name}
                        id="instrId" name="instructor_name"
                        placeholder="Enter the name"
                        className="md-cell md-cell--12"
                        required
                    />
                </DialogContainer>
                 */}
                <DialogContainer
                    id="simple-action-dialog"
                    visible={this.state.visible}
                    onHide={this.hide}
                    actions={actions}
                    //title="New Instructor"
                    width="500px"
                    key="AddInstructorDialog"
                >
                    <h2><label for="instrId">Update Instructor</label></h2>
                    <TextField
                        value={this.state.temp_instructor.instructor_name}
                        onChange={value => this.changeInstructorName(value)}
                        disabled
                        id="instrId"
                        label="User Id"
                        placeholder="Enter the User Id..."
                        className="md-cell md-cell--12"
                    />
                    <TextField
                        value={this.state.temp_instructor.instructor_first_name}
                        onChange={this.changeInstructorFirstName}
                        id="instrId"
                        label="First Name"
                        placeholder="Enter the First Name of the User..."
                        className="md-cell md-cell--12"
                    />
                    <TextField
                        value={this.state.temp_instructor.instructor_last_name}
                        onChange={this.changeInstructorLastName}
                        id="instrId"
                        label="Last Name"
                        placeholder="Enter the Last Name of the User..."
                        className="md-cell md-cell--12"
                    />
                </DialogContainer>


                <SFUserDetailModal
                    open={this.state.showActionRequired}
                    handleClose={() => this.setState({ showActionRequired: false })}
                    userName={this.state.selectedUserName}
                    actionButtons={
                        <React.Fragment>
                            <MButton variant='contained' color='success' startIcon={<FaCheck />}
                                onClick={() => {
                                    let reason = "";
                                    if (this.state.hideRejectBtn) {
                                        let rejectedInstructor = this.state.rejectedInstructors.find(inst => inst.instructor_name === this.state.selectedUserName);
                                        if (rejectedInstructor && rejectedInstructor.rejection_reason) {
                                            reason = rejectedInstructor.rejection_reason;
                                        }
                                    }
                                    this.handleApproval(this.state.selectedUserName, Approval.APPROVED, reason)
                                }}
                            >
                                Approve
                            </MButton>
                            {this.state.hideRejectBtn ? null :
                                <MButton variant='contained' color='error' startIcon={<IoClose />}
                                    onClick={() => {
                                        this.setState({
                                            showRejectUser: true,
                                        })
                                        // this.handleApproval(this.state.selectedUserName, Approval.REJECT)
                                    }}
                                >
                                    Reject
                                </MButton>}
                        </React.Fragment>
                    }
                />
                <RejectDialog
                    open={this.state.showRejectUser}
                    username={this.state.selectedUserName}
                    loading={this.state.rejectionLoading}
                    onClose={() => {
                        this.setState({ showRejectUser: false, rejectionLoading: false });
                    }}
                    onReject={(reason) => {
                        this.handleApproval(this.state.selectedUserName, Approval.REJECT, reason);
                    }}
                />
            </React.Fragment>

        );
    }
}

const RejectDialog = ({ open, username, onClose, onReject, loading }) => {
    const [reason, setReason] = useState("");

    useEffect(() => {
        setReason("");
    }, [open])

    const handleReject = () => {
        if (onReject) {
            console.debug("reason.length", reason.length)
            if (reason === "") {
                NotificationManager.error("Please give a reason")
                return;
            }
            onReject(reason);
        };
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Reject User</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" gutterBottom>
                    Username: <strong>{username}</strong>
                </Typography>
                <Typography variant="h6" gutterBottom>
                    Are you sure you want to reject this user?
                </Typography>
                <MTextField
                    label="Reason"
                    placeholder="Enter your reason"
                    fullWidth
                    multiline
                    minRows={3}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    sx={{ marginTop: 2 }}
                />
            </DialogContent>
            <DialogActions>
                <MButton variant="outlined" disabled={loading} onClick={onClose}>Cancel</MButton>
                <MButton variant="contained" disabled={loading} onClick={handleReject}>
                    {loading ? <CircularProgress style={{marginRight:"4px"}} size={16} /> : null}
                    Reject
                </MButton>
            </DialogActions>
        </Dialog>
    );
};
